import React from 'react';

import './index.scss';

const BubbleStaff = ({ message }) => {
  return (
    <div className="staff-text">
      <div className="staff-text__bubble">
        <p>{message}</p>
      </div>
    </div>
  );
};

export default BubbleStaff;
